import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminOrgListItem, AdminOrgDetail, AdminOrgUpdateRequest, AdminTransferOwnershipRequest } from '../types/organizations';

export const organizationsApi = {
  list: (params: PaginationParams) =>
    apiClient.get<PaginatedResponse<AdminOrgListItem>>('/organizations', { params }).then((r) => r.data),
  detail: (id: string) =>
    apiClient.get<AdminOrgDetail>(`/organizations/${id}`).then((r) => r.data),
  update: (id: string, data: AdminOrgUpdateRequest) =>
    apiClient.patch<MessageResponse>(`/organizations/${id}`, data).then((r) => r.data),
  transferOwnership: (id: string, data: AdminTransferOwnershipRequest) =>
    apiClient.post<MessageResponse>(`/organizations/${id}/transfer-ownership`, data).then((r) => r.data),
};
